import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

type Props = {
    from?: string;
    to: string;
};

export function BrowserHistoryReplace({ from, to }: Props): JSX.Element | null {
    const history = useHistory();
    useEffect(() => {
        if (history.location.pathname === from || !from) {
            history.replace(to);
        }
    }, [from, to, history]);

    return null;
}
